import { call, put, takeLatest } from "redux-saga/effects";
import { getEnterpriseEnquiry } from "../../utils/EnterprisesEnquiry/EnterprisesEnquiry";
import {
    GET_ENTERPRISE_ENQUIRY,
    getEnterpriseEnquirySuccess,
    getEnterpriseEnquiryFailure,
} from "../actions/enterprisesEnquiryAction";

function* handleGetEnterpriseEnquiry(action: any): Generator<any, void, any> {
    try {
        const response = yield call(
            getEnterpriseEnquiry,
            action.payload.fromdate,
            action.payload.todate
        );

        if (response?.data?.status === 200) {
            yield put(getEnterpriseEnquirySuccess(response.data.data));
        } else {
            yield put(getEnterpriseEnquiryFailure(response?.data?.message || "Data not Found"));
        }
    } catch (error: any) {
        yield put(
            getEnterpriseEnquiryFailure(
                error?.response?.data?.message || error?.message || "Something went wrong"
            )
        );
    }
}

export function* enterpriseEnquirySaga() {
    yield takeLatest(GET_ENTERPRISE_ENQUIRY, handleGetEnterpriseEnquiry);
}